/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListNotificationsParams,
  PaginatedNotificationOut,
  ReminderSettingsIn,
  ReminderSettingsOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listNotificationsResponse200 = {
  data: PaginatedNotificationOut
  status: 200
}

export type listNotificationsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listNotificationsResponseSuccess = (listNotificationsResponse200) & {
  headers: Headers;
};
export type listNotificationsResponseError = (listNotificationsResponse422) & {
  headers: Headers;
};

export type listNotificationsResponse = (listNotificationsResponseSuccess | listNotificationsResponseError)

export const getListNotificationsUrl = (params?: ListNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notifications?${stringifiedParams}` : `/api/notifications`
}

/**
 * @summary List Notifications
 */
export const listNotifications = async (params?: ListNotificationsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listNotificationsResponse> => {

  return apiFetch<listNotificationsResponse>(getListNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = (params?: ListNotificationsParams,) => {
    return [
    `/api/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = HTTPValidationError


export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params: undefined |  ListNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Notifications
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = HTTPValidationError>(
 params?: ListNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getReminderSettingsResponse200 = {
  data: ReminderSettingsOut
  status: 200
}

export type getReminderSettingsResponseSuccess = (getReminderSettingsResponse200) & {
  headers: Headers;
};
;

export type getReminderSettingsResponse = (getReminderSettingsResponseSuccess)

export const getGetReminderSettingsUrl = () => {




  return `/api/orgs/current/reminders`
}

/**
 * @summary Get Reminder Settings
 */
export const getReminderSettings = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getReminderSettingsResponse> => {

  return apiFetch<getReminderSettingsResponse>(getGetReminderSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReminderSettingsQueryKey = () => {
    return [
    `/api/orgs/current/reminders`
    ] as const;
    }


export const getGetReminderSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReminderSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReminderSettings>>> = ({ signal }) => getReminderSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReminderSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getReminderSettings>>>
export type GetReminderSettingsQueryError = unknown


export function useGetReminderSettings<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderSettings>>,
          TError,
          Awaited<ReturnType<typeof getReminderSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReminderSettings<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReminderSettings>>,
          TError,
          Awaited<ReturnType<typeof getReminderSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReminderSettings<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Reminder Settings
 */

export function useGetReminderSettings<TData = Awaited<ReturnType<typeof getReminderSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReminderSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReminderSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setReminderSettingsResponse200 = {
  data: ReminderSettingsOut
  status: 200
}

export type setReminderSettingsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setReminderSettingsResponseSuccess = (setReminderSettingsResponse200) & {
  headers: Headers;
};
export type setReminderSettingsResponseError = (setReminderSettingsResponse422) & {
  headers: Headers;
};

export type setReminderSettingsResponse = (setReminderSettingsResponseSuccess | setReminderSettingsResponseError)

export const getSetReminderSettingsUrl = () => {




  return `/api/orgs/current/reminders`
}

/**
 * @summary Set Reminder Settings
 */
export const setReminderSettings = async (reminderSettingsIn: ReminderSettingsIn, options?: Parameters<typeof apiFetch>[1]): Promise<setReminderSettingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setReminderSettingsResponse>(getSetReminderSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reminderSettingsIn)
  }
);}





export const getSetReminderSettingsMutationKey = () => ['setReminderSettings'] as const;

export const getSetReminderSettingsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setReminderSettings>>, TError,SetReminderSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setReminderSettings>>, TError,SetReminderSettingsMutationVariables, TContext> => {

const mutationKey = getSetReminderSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setReminderSettings>>, SetReminderSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setReminderSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetReminderSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof setReminderSettings>>>
    export type SetReminderSettingsMutationBody = ReminderSettingsIn
    export type SetReminderSettingsMutationError = HTTPValidationError
    export type SetReminderSettingsMutationVariables = {data: ReminderSettingsIn}

    /**
 * @summary Set Reminder Settings
 */
export const useSetReminderSettings = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setReminderSettings>>, TError,SetReminderSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setReminderSettings>>,
        TError,
        SetReminderSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getSetReminderSettingsMutationOptions(options), queryClient);
    }
